import { render, staticRenderFns } from "./ResetPasswordLoggedIn.vue?vue&type=template&id=1c9a54df"
import script from "./ResetPasswordLoggedIn.vue?vue&type=script&lang=js"
export * from "./ResetPasswordLoggedIn.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordLoggedIn.vue?vue&type=style&index=0&id=1c9a54df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports